import { recordOverlapsNavigatorRange } from "./timeNavigatorRange";
import { normalizeVolunteerOpportunityStatus } from "./volunteerOpportunityDisplay";

/**
 * Opportunity-scoped filters shared by Volunteer Opportunities and Volunteer Participants lists.
 * @param {object} record - opportunity row or participant row with opportunity_* fields
 */
export function matchesVolunteerOpportunityScopeFilters(
  record,
  { timeNav, eventId, statusFilter, category, opportunityId }
) {
  const oppId = opportunityId != null ? String(opportunityId).trim() : "";
  const recordOppId = String(
    record?.volunteer_opportunity_id || record?._id || record?.opportunity_id || ""
  ).trim();
  if (oppId && recordOppId !== oppId) return false;

  const eventIdNorm = eventId != null ? String(eventId).trim() : "";
  const recordEventId = String(record?.event_id || record?.opportunity_event_id || "").trim();
  if (eventIdNorm && recordEventId !== eventIdNorm) return false;

  const statusNorm = statusFilter ? normalizeVolunteerOpportunityStatus(statusFilter) : "";
  const recordStatus = normalizeVolunteerOpportunityStatus(
    record?.status ?? record?.opportunity_status
  );
  if (statusNorm && recordStatus !== statusNorm) return false;

  const categoryNorm = (category || "").trim().toLowerCase();
  const recordCategory = (record?.category ?? record?.opportunity_category ?? "").trim().toLowerCase();
  if (categoryNorm && recordCategory !== categoryNorm) return false;

  const timeRecord = {
    start_datetime: record?.start_datetime ?? record?.opportunity_start_datetime,
    end_datetime: record?.end_datetime ?? record?.opportunity_end_datetime,
  };
  if (!recordOverlapsNavigatorRange(timeRecord, timeNav?.bounds, timeNav?.view)) return false;

  return true;
}

/** Participant list: search volunteers first; also match linked opportunity fields. */
export function matchesVolunteerParticipantSearch(record, searchTerm) {
  const searchLower = (searchTerm || "").toLowerCase().trim();
  if (!searchLower) return true;
  const fullName = [record?.first_name, record?.last_name]
    .filter(Boolean)
    .map((s) => String(s).trim())
    .join(" ")
    .toLowerCase();
  return (
    (fullName && fullName.includes(searchLower)) ||
    (record?.first_name && String(record.first_name).toLowerCase().includes(searchLower)) ||
    (record?.last_name && String(record.last_name).toLowerCase().includes(searchLower)) ||
    (record?.email && String(record.email).toLowerCase().includes(searchLower)) ||
    (record?.phone && String(record.phone).toLowerCase().includes(searchLower)) ||
    (record?.opportunity_name && String(record.opportunity_name).toLowerCase().includes(searchLower)) ||
    (record?.opportunity_category && String(record.opportunity_category).toLowerCase().includes(searchLower)) ||
    (record?.opportunity_location && String(record.opportunity_location).toLowerCase().includes(searchLower)) ||
    (record?.opportunity_status &&
      String(record.opportunity_status).toLowerCase().includes(searchLower))
  );
}

/** Opportunity list free-text search (name, description, location, category, status). */
export function matchesVolunteerOpportunitySearch(record, searchTerm) {
  const searchLower = (searchTerm || "").toLowerCase().trim();
  if (!searchLower) return true;
  return (
    (record?.name && record.name.toLowerCase().includes(searchLower)) ||
    (record?.description && record.description.toLowerCase().includes(searchLower)) ||
    (record?.location && record.location.toLowerCase().includes(searchLower)) ||
    (record?.category && record.category.toLowerCase().includes(searchLower)) ||
    (record?.status && record.status.toLowerCase().includes(searchLower))
  );
}
